type ProgressIndicationProps = {
  text?: string | React.ReactNode;
  progress: number;
  showProgress?: boolean;
};

export const ProgressIndicator = ({
  text,
  progress,
  showProgress = true,
}: ProgressIndicationProps) => {
  return (
    <div className="bg-purple-9D8AFF/[7%] px-7 py-[19px] rounded-lg">
      {text && <div>{text}</div>}
      {showProgress && (
        <div className="mt-3 flex flex-1 items-center gap-3">
          <div className="h-3 flex flex-1 bg-purple-9D8AFF/[15%] rounded-full">
            <div
              className="h-full bg-purple-A713F6 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="font-medium">{progress} %</div>
        </div>
      )}
    </div>
  );
};
